import { useCloseLedgerDrawer, useLedgerDrawerProps } from './store/hooks';
import PatientLedgerDrawer from './PatientLedgerDrawer';

/**
 * Mount point for the Patient Ledger Drawer. Reads slice state and
 * renders the drawer when there are open props.
 *
 * Mounted globally next to GlobalModalManager (see auth0-provider.tsx).
 * The drawer is its own MUI Drawer — no wrapper Dialog, no modal stack —
 * so all the focus/scroll-lock/backdrop fights from the previous
 * registry-based approach disappear.
 */
export const PatientLedgerDrawerHost = () => {
  const props = useLedgerDrawerProps();
  const close = useCloseLedgerDrawer();
  if (!props) return null;
  return <PatientLedgerDrawer {...props} onClose={close} />;
};
